import http from "@/http/aisea/axios";
const resource = "/enterprises/features/permissions";

export default {
  fetch() {
    return http.get(`${resource}`);
  },
};
